import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('customer-data-filters', {
  library: 'customer-data-filters'
});